import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      document.title = `Inbox - ${state.user.email}@gmail.com  - Mail Box`
    },
    logout: (state) => {
      state.user = null;
      document.title = 'Shops MMO Mail Box'
    },
  },
});

export const { login, logout } = userSlice.actions;

export const selectUser = (state) => state.user.user;

export default userSlice.reducer;
